@if (operation) {
  <div class="flex-vertical width-100pc">
    <div class="headerContent padding-24 flex-vertical width-100pc gap-16">
      <div class="flex-horizontal">
        <oui-button type="icon" color="secondary" (click)="onBackArrowClick()">
          <oui-icon>arrow_back</oui-icon>
        </oui-button>
        <div class="flex-1 width-100pc"></div>
        @if (!isConsultant) {
          <oui-menu [menuItems]="menuGestionnaire" horizontalPosition="right" verticalPosition="bottom">
            <oui-button type="icon" color="secondary">
              <oui-icon>more_vert</oui-icon>
            </oui-button>
          </oui-menu>
        }
      </div>
      <div class="flex-vertical gap-4">
        <h5>
          Opération N°<span>{{ operation.id }}</span>
        </h5>
        <div class="body-2 color-on-surface-medium max-width-177">
          Déclarée le {{ (operation.dateDeclaration | date: 'dd/MM/yyyy') ?? ' --/--/--' }}
        </div>
        <div class="flex-horizontal">
          <a class="cursor-pointer body-2" (click)="onHistoriqueClick()">Historique</a>
          <div class="flex-1"></div>
        </div>
      </div>
      <div class="flex-horizontal flex-center gap-12">
        <div class="flex-horizontal justify-center gap-4">
          <app-operation-statut-tag [statut]="operation.statut"></app-operation-statut-tag>
          @for (tag of staticTags; track tag) {
            @if (getAppearance(tag).kind === 'status') {
              <oui-tag
                size="big"
                type="status"
                [status]="getAppearance(tag).status"
                [declination]="getAppearance(tag).declination">
                {{ tag.libelle }}
              </oui-tag>
            } @else {
              <oui-tag size="big" type="brand" brand="placement" [declination]="getAppearance(tag).declination">
                {{ tag.libelle }}
              </oui-tag>
            }
          }
        </div>
        <div class="flex-1"></div>
        @if (isGestionnaire) {
          <a class="cursor-pointer body-2" (click)="openFicheLiaisonDialog()">Fiche de liaison</a>
        }
      </div>
      @if (tagOptions && !isConsultant) {
        <oui-select-filter
          [control]="tagControl"
          [listOptions]="tagOptions"
          type="list"
          label="Sélectionner des tags"
          listPlaceholder="Sélectionnez des tags"></oui-select-filter>
      }
      <div class="chips-overflow-container">
        <oui-chip-list type="selection" [noWrap]="false">
          @for (tagChip of tagChips; track tagChip) {
            <oui-chip (remove)="onRemoveTag(tagChip.value)" [oui-dialog-close]="tagChip.data.isPermanent">{{
              tagChip.label
            }}</oui-chip>
          }
        </oui-chip-list>
        @if (tagChips.length > 0) {
          <oui-button type="text" color="primary" (click)="onClearTags()">Effacer les tags </oui-button>
        }
      </div>
      @if (!isConsultant && isTriggerIncluded(OPERATION_MAIL_RECEPTION_TRIGGER)) {
        <oui-button iconPrefix="check" (click)="onDeclareMailReception()"
          >Déclarer la réception des originaux</oui-button
        >
      }
      @if (emailInError && emailInError.length > 0 && !isConsultant) {
        <div>
          <oui-banner title="L’e-mail partenaire n’a pas été reçu" declination="error" type="expandable">
            <div>
              <div>
                <div class="body-2">Code erreur : {{ emailInError[0].statutMessage }}</div>
                <div class="body-2 color-on-surface-medium">
                  Vous pouvez cliquer ci-dessous pour l’envoyer à nouveau
                </div>
              </div>
              <div class="top-margin-16">
                <oui-button type="contained" (click)="onSendPartenaireEmailClick()">E-mail Partenaire</oui-button>
              </div>
            </div>
          </oui-banner>
        </div>
      }
      @if (showConsultantCommentBanner) {
        <oui-banner
          #consultantCommentBanner
          title="Commentaire du consultant"
          declination="info"
          type="complex"
          [description]="specificData.commentaire ?? ''"
          [showCloseButton]="!isMarkingConsultantCommentAsRead"
          (closed)="markConsultantCommentAsRead(consultantCommentBanner)">
        </oui-banner>
      }
    </div>
    @if (isGestionnaire) {
      <div class="operation-panel-section">
        <oui-pair-info
          label="Gestionnaire"
          [value]="$safeNavigationMigration(operation.gestionnaire?.displayName) ?? ''"
          [editable]="isAdmin"
          emptyButtonText="A renseigner"
          (edit)="onGestionnaireClick()">
        </oui-pair-info>
      </div>
    }
    @if (isGestionnaire) {
      <div class="operation-panel-section">
        <oui-accordion [expanded]="true">
          <oui-accordion-header>
            <oui-accordion-title>Commande</oui-accordion-title>
          </oui-accordion-header>
          <div class="panel-accordion-content">
            <oui-pair-info
              label="Commande Aramis"
              level="secondary"
              [value]="operation.contrat?.numCommande ?? undefined"
              [editable]="isCommandEditable()"
              (edit)="editAramisCommande()"></oui-pair-info>
          </div>
        </oui-accordion>
      </div>
    }
    @if (isGestionnaire) {
      <div class="operation-panel-section">
        <oui-accordion>
          <oui-accordion-header>
            <oui-accordion-title>Consultant</oui-accordion-title>
            @if (isConsultantHabilitationWarning) {
              <oui-accordion-description class="color-error body-2">
                <oui-icon class="color-error">gpp_bad</oui-icon>
                <span>{{ consultant.displayName }}</span>
              </oui-accordion-description>
            } @else {
              <oui-accordion-description class="body-2">
                {{ consultant.displayName }}
              </oui-accordion-description>
            }
          </oui-accordion-header>
          <div class="flex-vertical gap-24 padding-top-18">
            <div class="flex-horizontal gap-16">
              <div class="photoframe">
                <oui-icon>person_black_24dp</oui-icon>
              </div>
              <div class="flex-vertical body-2 gap-6">
                <div class="body-2 color-on-surface-medium">Consultant(e)</div>
                <div>{{ consultant.displayName }}</div>
                <div>{{ consultant.phoneNumber }}</div>
                @if (consultant.mailToLink) {
                  <div>
                    <a [href]="consultant.mailToLink" class="body-2">{{ consultant.email }}</a>
                  </div>
                }
                <div>
                  <span class="color-on-surface-medium">Taux de commissionnement : </span
                  >{{ consultant.commisionnement }}
                </div>
                <div><span class="color-on-surface-medium">Titre : </span>{{ consultant.titre }}</div>
              </div>
            </div>
            @for (assistant of assistants; track assistant) {
              <div class="flex-horizontal gap-12">
                <div class="photoframe"><oui-icon>frame_person</oui-icon></div>
                <div class="flex-vertical body-2">
                  <div class="body-2 color-on-surface-medium">Assistant(e)</div>
                  <div>{{ assistant.displayName }}</div>
                  <div>{{ assistant.phoneNumber ?? '-' }}</div>
                  @if (assistant.mailToLink) {
                    <div>
                      <a [href]="assistant.mailToLink" class="body-2">{{ assistant.email }}</a>
                    </div>
                  }
                </div>
              </div>
            }
            <div class="flex-vertical gap-8">
              <div class="body-2 color-on-surface-medium">Habilitations</div>
              <div class="flex-vertical gap-4">
                @for (hab of consultantHabilitations; track hab) {
                  <div class="flex-horizontal flex-center gap-8 body-2">
                    <oui-icon [class]="hab.class">{{ hab.icon }}</oui-icon>
                    <div
                      [ngClass]="{
                        'width-124': true,
                        bold: hab.isOperationHabilitation,
                      }">
                      {{ hab.libelle }}
                    </div>
                    <div class="body-2 color-on-surface-medium">
                      du
                      {{ formatDate(hab.startDate) }} au
                      {{ formatDate(hab.endDate) }}
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </oui-accordion>
      </div>
    }
    <div class="operation-panel-section">
      <oui-accordion [expanded]="true">
        <oui-accordion-header>
          <oui-accordion-title>Investisseurs</oui-accordion-title>
        </oui-accordion-header>
        <div class="panel-accordion-content">
          @if (operation.investisseur?.investisseurEntite) {
            <oui-pair-info
              label="Investisseur"
              level="secondary"
              value="{{ operation.investisseur.investisseurEntite?.displayName }}"
              [editable]="false"></oui-pair-info>
          }
          @if (operation.investisseur?.code && isGestionnaire) {
            <oui-pair-info
              label="Code CLT"
              level="secondary"
              value="{{ operation.investisseur.code }}"
              [editable]="false"></oui-pair-info>
          }
          @if (operation.coInvestisseur?.investisseurEntite) {
            <oui-pair-info
              label="Investisseur"
              level="secondary"
              value="{{ operation.coInvestisseur?.investisseurEntite?.displayName }}"
              [editable]="false"></oui-pair-info>
          }
          @if (operation.coInvestisseur?.code && isGestionnaire) {
            <oui-pair-info
              label="Code CLT"
              level="secondary"
              value="{{ operation.coInvestisseur?.code }}"
              [editable]="false"></oui-pair-info>
          }
        </div>
      </oui-accordion>
    </div>
    <div class="operation-panel-section">
      <oui-accordion [expanded]="true">
        <oui-accordion-header>
          <oui-accordion-title>Informations</oui-accordion-title>
        </oui-accordion-header>
        <div class="panel-accordion-content">
          <oui-pair-info
            label="Nature"
            level="secondary"
            [value]="operation.operationConfig?.natureOperation?.libelle ?? ''"
            [editable]="false"></oui-pair-info>
          <oui-pair-info
            label="Enveloppe"
            level="secondary"
            [value]="operation.produit?.enveloppeNavigation?.libelle ?? ''"
            [editable]="false"></oui-pair-info>
          <oui-pair-info
            label="Produit"
            level="secondary"
            [value]="operation.produit?.nomTechniqueProduitBox ?? operation.produit?.nom ?? ''"
            [editable]="false"></oui-pair-info>
          @if (operation.operationType != 'SOUSCRIPTION' && operation.contrat) {
            <oui-pair-info
              label="Contrat N°"
              level="secondary"
              [value]="operation.contrat.numeroContrat ?? ''"
              [editable]="false"></oui-pair-info>
          }
          @if (operation.montant != null && operation.montant != undefined) {
            <oui-pair-info
              label="Montant de l'opération"
              level="secondary"
              value="{{ operation.montant | currency: 'EUR' }}"
              [editable]="isInformationsEditable"
              (edit)="openEditDialog('montant', operation.montant)"></oui-pair-info>
          }
          @if (operation.transactionPersonnelleStatut != null) {
            <oui-pair-info
              label="Transaction personnelle"
              level="secondary"
              [value]="wrapTransactionPersonnelleStatut(operation.transactionPersonnelleStatut)"
              [editable]="isInformationsEditable"
              (edit)="
                openEditDialog('transaction-personnelle', operation.transactionPersonnelleStatut)
              "></oui-pair-info>
          }
          @if (specificData) {
            @if (versementsProgrammesDisplayValue) {
              <oui-pair-info
                label="Mise en place de versements programmés"
                level="secondary"
                value="{{ versementsProgrammesDisplayValue }}"
                [editable]="false"></oui-pair-info>
            }
            @if (reinvestissementDividendesDisplayValue) {
              <oui-pair-info
                label="Mise en place du réinvestissement des dividendes"
                level="secondary"
                value="{{ reinvestissementDividendesDisplayValue }}"
                [editable]="false"></oui-pair-info>
            }
            @if (
              (operation.fondEvenementiels?.length ?? 0 > 0) ||
              (isInformationsEditable &&
                (operation.produit?.fondEvenementielExtension?.fondsEvenementiels?.length ?? 0 > 0))
            ) {
              <oui-pair-info
                label="Fonds Evènementiels"
                level="secondary"
                [value]="fondsEvenementiels"
                [editable]="isInformationsEditable"
                (edit)="openEditDialog('fondsEvenementiels', operation.fondEvenementiels)"></oui-pair-info>
            }
            @if (specificData.modePaiement && specificData.modePaiement.length) {
              <oui-pair-info
                label="Mode de paiement"
                level="secondary"
                [value]="modesPaiement ?? ''"
                [editable]="isInformationsEditable"
                (edit)="openEditDialog('modePaiement', specificData.modePaiement)"></oui-pair-info>
            }
            @if (specificData.objetModification && specificData.objetModification.length) {
              <oui-pair-info
                label="Objet de la modification"
                level="secondary"
                [value]="objetsModification ?? ''"
                [editable]="isInformationsEditable"
                (edit)="openEditDialog('objetModification', specificData.objetModification)"></oui-pair-info>
            }
            @if (specificData.demembrement) {
              <oui-pair-info
                label="Démembrement"
                level="secondary"
                [value]="demembrement ?? ''"
                [editable]="false"></oui-pair-info>
            }
            @if (specificData.demembrement && specificData.demembrement != 'Viager') {
              <oui-pair-info
                label="Contrepartie connue ?"
                level="secondary"
                [value]="isContrepartie"
                [editable]="false"></oui-pair-info>
            }
            @if (specificData.demembrement && contrepartieName) {
              <oui-pair-info
                label="Contrepartie"
                level="secondary"
                [value]="contrepartieName"
                [editable]="isInformationsEditable"
                (edit)="openEditDialog('contrepartieName', specificData.contrepartieName)"></oui-pair-info>
            }
            @if (typeTauxFrais) {
              <oui-pair-info
                label="Type de taux de frais"
                level="secondary"
                [value]="typeTauxFrais"
                [editable]="isInformationsEditable"
                (edit)="openEditDialog('tauxFrais', specificData.typeTauxFrais)"></oui-pair-info>
            }
            @if (impactDiminutionFrais) {
              <oui-pair-info
                label="Impact diminution des frais"
                level="secondary"
                [value]="impactDiminutionFrais"
                [editable]="isInformationsEditable"
                (edit)="openEditDialog('tauxFrais', specificData.typeTauxFrais)"></oui-pair-info>
            }
            @if (operation.typeSignaturePartenaire) {
              <oui-pair-info
                label="Comment ont été signés les documents du partenaire ? (hors documents Stellium)"
                level="secondary"
                [value]="typeSignature ?? ''"
                [editable]="isInformationsEditable"
                (edit)="openEditDialog('typeSignaturePartenaire', operation.typeSignaturePartenaire)"></oui-pair-info>
            }
            @if (transmissionOriginaux) {
              <oui-pair-info
                label="Transmission des originaux"
                level="secondary"
                [value]="transmissionOriginaux"
                [editable]="isInformationsEditable"
                (edit)="openEditDialog('typeSignaturePartenaire', operation.typeSignaturePartenaire)"></oui-pair-info>
            }
            @if (specificData.commentaire) {
              <oui-pair-info
                label="Commentaire"
                level="secondary"
                [value]="specificData.commentaire"
                [editable]="false"
                orientation="vertical"></oui-pair-info>
            }
          }
        </div>
      </oui-accordion>
    </div>
    <div class="background-white flex-1 filler"></div>
  </div>
}
